import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import axios from "axios";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.scss";
import AnalyticsProvider from "./providers/AnalyticsProvider";
import SentryProvider from "./providers/SentryProvider";
import reportWebVitals from "./reportWebVitals";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1 * 60 * 1000, // on default, preserve data for 1 minute
      refetchOnWindowFocus: false,
    },
  },
});

axios.defaults.baseURL =
  process.env.REACT_APP_BASE_URL || "https://api-dev-eu.root-sustainability.com";

axios.defaults.paramsSerializer = (params) => {
  var encodedParams = [];
  for (var key in params) {
    encodedParams.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]));
  }

  return encodedParams.join("&");
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AnalyticsProvider>
        <SentryProvider>
          <App />
          <ReactQueryDevtools initialIsOpen={false} />
        </SentryProvider>
      </AnalyticsProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
